


































import { Vue, Component, Prop, Watch, Ref  } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { SaveClienteUseCase, FindLojaUseCase } from '@/usecases'
import type { Cliente } from '@/models'
import { emailDoClienteInvalido } from '@/shareds/regras-de-form'

@Component
export default class DialogoDeEdicaoEmailCliente extends Vue {
	@Prop({type: Object})cliente?: Cliente
	mostra = false
	salvando = false
	saveClienteUseCase = new SaveClienteUseCase()
	findLojaUseCase = new FindLojaUseCase()
	clienteEmEdicao: string | undefined = undefined
	emailDoClienteInvalido = emailDoClienteInvalido

	@Ref() form!: HTMLFormElement

	mostrar() {
		this.mostra = true
	}

	esconder() {
		this.clienteEmEdicao = undefined
		this.mostra = false
	}

	async salvar() {
		if (!this.cliente) return
		if (!this.clienteEmEdicao) return
		if (!this.form.validate()) return

		try {
			this.salvando = true

			const clienteParaSalvar = await this.comLojasCompletas(this.cliente)
			clienteParaSalvar.email = this.clienteEmEdicao.trim()

			await this.saveClienteUseCase.update(clienteParaSalvar)

			this.editarCliente()
			this.mostra = false
			AlertModule.setSuccess('Cliente salvo com sucesso')
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}

	async comLojasCompletas(cliente: Cliente): Promise<Cliente> {
		const lojasIncompletas = cliente.lojas.filter(loja => loja.configuracaoDaLoja === null)
		if (!lojasIncompletas.length) return cliente

		const lojasCompletas = await this.findLojaUseCase.findLojasByListId(lojasIncompletas.map(loja => loja.id))
		return { ...cliente, lojas: lojasCompletas }
	}

	editarCliente() {
		if(this.cliente && this.clienteEmEdicao) this.cliente.email = this.clienteEmEdicao.trim()
	}

	normalizarEmail() {
		if (!this.clienteEmEdicao) return
		this.clienteEmEdicao = this.clienteEmEdicao.trim()
	}

	@Watch('cliente')
	onChangeCliente() {
		this.clienteEmEdicao = this.cliente?.email
	}
}
